export interface IAMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface IAProvider {
  sendMessageStream: (messages: IAMessage[], systemPrompt?: string, options?: {
    model?: string;
    temperature?: number;
  }) => AsyncIterable<string>;
}

// Provider mock (streaming)
async function* mockSendMessageStream(messages: IAMessage[], systemPrompt?: string): AsyncGenerator<string, void, void> {
  console.log('mockSendMessageStream', messages, systemPrompt);
  const lastUserMessage = messages.filter(m => m.role === 'user').slice(-1)[0]?.content || '';
  const mock = `Voici une réponse simulée de l'IA à : "${lastUserMessage}".\nCeci est un exemple de streaming.`;
  let current = '';
  for (const char of mock) {
    current += char;
    yield current;
    await new Promise((r) => setTimeout(r, 20));
  }
}

export const mockIAProvider: IAProvider = {
  sendMessageStream: mockSendMessageStream,
};

// Provider OpenAI (clé en dur pour POC, à retirer en prod !)
import OpenAI from 'openai';

const OPENAI_API_KEY = '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'; // TODO: Retirer cette clé en prod !
const SYSTEM_PROMPT = "Tu es un assistant SAV. Réponds de façon concise et professionnelle.";

const openaiClient = new OpenAI({
  apiKey: OPENAI_API_KEY,
  dangerouslyAllowBrowser: true, // ⚠️ Pour POC uniquement !
});

export const openaiIAProvider: IAProvider = {
  async *sendMessageStream(messages: IAMessage[], systemPrompt?: string, options?: {
    model?: string;
    temperature?: number;
  }) {
    const stream = await openaiClient.chat.completions.create({
      model: options?.model || 'gpt-4.1',
      messages: [
        { role: 'system', content: systemPrompt || SYSTEM_PROMPT },
        ...messages,
      ],
      stream: true,
      temperature: options?.temperature || 0.7,
    });
    for await (const chunk of stream) {
      const delta = chunk.choices?.[0]?.delta?.content;
      if (delta) {
        yield delta;
      }
    }
  },
};